import React, { useCallback, useEffect, useState } from "react";
import { Col, Row, Button, Modal, Form } from "antd";
import { FleetTable } from "./fleetTable";
import "./style.css";
import { BUTTONS, FORMS } from "../common/constants";
import CreateFleetForm from "./form";
import CreateFleetVehicleForm from "./addVehicleForm ";
import { getApis, postApis, putApis } from "../common/api";
import { fleetsUrl, vehicleListApiUrl } from "../common/endpoints";
import { useSelector } from "react-redux";
import ChangeOrganisation from "../common/ChangeOrganisation";
import { getFleetFormValues } from "./getFleetFormValues";
import { toast } from "react-toastify";

const Fleets = () => {
  const orgDetails = useSelector((state) => state.org);
  const authToken = localStorage.getItem("authToken");
  const [vehicleList, setVehicleList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fleetVehicleModal, setFleetVehicleModal] = useState({
    visible: false,
    loader: false,
    vehicleImei: []
  });
  const [fleetList, setFleetList] = useState([]);
  const [form] = Form.useForm();

  const getFleets = async () => {
    await getApis(fleetsUrl, {}, orgDetails?.token)
      .then((response) => {
        setFleetList(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setFleetList([]);
    });
  };

  const getImeiList = useCallback(async () => {
    const response = await getApis(
      vehicleListApiUrl,
      {
        page: 0,
        size: 1000,
      },
      orgDetails?.token || authToken
    );
    setVehicleList(response?.data || []);

    // eslint-disable-next-line
  }, [orgDetails?.token]);

  useEffect(() => {
    if (orgDetails?.token) {
      getFleets();
      getImeiList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgDetails?.token]);

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    await postApis(
      fleetsUrl,
      getFleetFormValues(values),
      orgDetails?.token
    )
      .then((response) => {
        if(response?.data?.fleetId) {
          toast.success("Fleet created successfully");
          setModalOpen(false);
          getFleets();
        } else {
          toast.error(response?.data?.message)
        }
      })
      .catch((error) => toast.error(error?.response?.data?.message));
    setIsLoading(false);
  };

  const AddVehicleFun = (data) => {
    setFleetVehicleModal((prev) => ({
      ...prev,
      fleetId: data?.fleetId,
      vehicleImei: data?.vehicleImei,
      visible: true,
    }));
  };

  const handleFleetVehicleModalCancel = () => {
    setFleetVehicleModal({ visible: false, loader: false });
  };

  const handleVehicleFormSubmit = async (values) => {
    const data = {
      id: fleetVehicleModal?.fleetId,
      imeis: values?.imei,
    };
    await putApis(
      fleetsUrl,
      data,
      orgDetails?.token
    )
      .then((response) => {
        if(response?.data?.fleetId) {
          toast.success("Fleet updated successfully");
          getFleets();
          setFleetVehicleModal({ visible: false, loader: false });
        } else {
          toast.error(response?.data?.message)
        }
      })
      .catch((error) => toast.error(error?.response?.data?.message));
      setFleetVehicleModal({ loader: false });
    };

  return (
    <>
      <Row justify="space-between" className="flex-center">
        <Col span={4} className="head">
          Fleets
        </Col>
        <Col xs={12} sm={8} md={6} lg={3}>
          <Button type="primary" onClick={() => setModalOpen(true)}>
            {BUTTONS.ADD_NEW}
          </Button>
        </Col>
      </Row>
      <ChangeOrganisation />
      <Row justify="center" className="mt1">
        <Col span={24}>
          <FleetTable
            fleetList={fleetList}
            fleetVehicleModalOpenFun={AddVehicleFun}
          />
        </Col>
      </Row>
      {modalOpen && (
        <Modal
          title={FORMS.FLEETS.HEADER}
          centered
          open={modalOpen}
          onOk={form.submit}
          onCancel={handleCancel}
          footer={null}
        >
          <CreateFleetForm
            orgId={orgDetails?.id}
            vehicleList={vehicleList}
            isLoading={isLoading}
            handleSubmit={handleSubmit}
          />
        </Modal>
      )}
      {fleetVehicleModal?.visible && (
        <Modal
          title={FORMS.FLEETS.VEHICLE.HEADER}
          centered
          open={fleetVehicleModal?.visible}
          onOk={form.submit}
          onCancel={handleFleetVehicleModalCancel}
          footer={null}
        >
          <CreateFleetVehicleForm
            vehicleList={vehicleList}
            fleetVehicleImei={fleetVehicleModal?.vehicleImei}
            isBtnLoader={fleetVehicleModal?.loader}
            handleSubmit={handleVehicleFormSubmit}
          />
        </Modal>
      )}
    </>
  );
};

export default Fleets;
